import React, { useCallback, useEffect, useState } from 'react';
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import './VendorListPage.css'

import ListTable from './VendorListTable';

import { getUserSession } from '../../utils/auth';
import { calculatePagination } from '../../utils/calculatePagination';
import { makeApiCall } from '../../Api/makeApiCall';
import { Api_Endpoints } from '../../Api/apiEndpoint';
import { SearchIcon } from '../../Constant/ImageConstant';
import FilterContainer from '../../components/FilterComponent/FilterContainer';
import { showErrorToast, showSuccessToast } from '../../utils/toastService';
import { useLocation } from 'react-router-dom';

const  ClaimListPage=()=> {
  const [error, setError] = useState("");
  const [dropDownData,setdropDownData]=useState([])

  const [filterValue,setFilterValue]=useState({
     searchParam:'',productType:'',Status:''
    }
      )

  const status=[
    {
      "id": 0,
      "label": "Pending"
  },
  {
      "id": 1,
      "label": "InProgress"
  },
  {
      "id": 2,
      "label": "Rejected"
  },
  {
      "id": 3,
      "label": "Refer Back"
  },
  {
    "id": 4,
    "label": "Completed"
},
]

const [windowWidth, setWindowWidth] = useState([window.innerWidth]);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, settotalPage] = useState();
  
    const [filterDrawerVisible, setFilterDrawerVisible] = useState(false);
  
    const handleOpenFilterDrawer = () => {
      setFilterDrawerVisible(true);
    };
  
    const handleCloseFilterDrawer = () => {
      setFilterDrawerVisible(false);
    };
    const [isRefreshButtonDisabled, setIsRefreshButtonDisabled] = useState(false);
  
    const [totalRecords, setTotalRecords] = useState("");
    const [VendorList, setVendorList] = useState([]);
  
    const [indexOfLastRecord, setIndexOfLastRecord] = useState(10);
    const [indexOfFirstRecord, setIndexOfFirstRecord] = useState(0);
    const recordsPerPage = 10;
    const [isMobile, setisMobile] = useState(false);
  
    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
      const pagination = calculatePagination(
        totalRecords,
        recordsPerPage,
        pageNumber
      );
      //  settotalPage(pagination?.totalPages);
      // setIndexOfFirstRecord()
      setIndexOfFirstRecord(pagination?.startIndex);
      // setIndexOfFirstRecord(pageNumber * recordsPerPage);
    };
  
          
  
    const refreshpage = () => {};
  
    const handleRefresh = () => {
      // Disable the button
      setIsRefreshButtonDisabled(true);
  
      GetVendorList();
  
      setTimeout(() => {
        // Enable the button after 10 seconds
        setIsRefreshButtonDisabled(false);
      }, 10000); // 10 seconds in milliseconds
    };
  


    const resetFilter=()=>{
      setFilterValue('')
      GetVendorList();
    }
    const GetVendorList = useCallback(() => {



      const decryptdata=''
      const data = getUserSession();
   

    
      const listdata = {
        type:0,
        status:1,
        page:currentPage,
        pageSize:10,
        // startDate:23/04/2024,
        // endDate:07/06/2024,
        searchTerm:''
      };
  
      
      if (indexOfFirstRecord !== indexOfLastRecord) {
        makeApiCall(Api_Endpoints.VENDOR_LIST, 'POST', listdata)
          .then((data) => {
            if (data?.status) {
              const processedData = data?.result.map((item, index) => {
                if (item.id === null) {
                  // Only modify items with null IDs
                  return { ...item, id: `temp-${index}-${Date.now()}` };
                }
                return item;
              });

              setVendorList(processedData);
              setTotalRecords(data?.total_items);
              settotalPage(data?.total_pages);
              setError(""); // Clear error on success
            } else {
              setError(data?.message || "No vendors found");
              setVendorList([]);
            }
          })
          .catch((error) => {
            setError("Failed to fetch vendor list. Please try again.");
            console.error(error);
          });
      }
    }, [filterValue, indexOfFirstRecord, indexOfLastRecord, totalRecords]);
  

  
    useEffect(() => {
      const handleWindowResize = () => {
        setWindowWidth([window.innerWidth]);
      };
  
      window.addEventListener("resize", handleWindowResize);
      if (windowWidth <= 768) {
        setisMobile(false);
      } else {
        setisMobile(true);
      }
      return () => {
        window.removeEventListener("resize", handleWindowResize);
      };
    }, [windowWidth]);
  
    useEffect(() => {
      setIndexOfLastRecord(currentPage * recordsPerPage);
    }, [currentPage, recordsPerPage, totalPage]);
  
    useEffect(() => {
      GetVendorList();
    }, [indexOfLastRecord, indexOfFirstRecord]);
  

const product=[
  
]

const location = useLocation();
// const filteredData = location.state;


const searchData = (filteredData) => {
  if(filteredData){
    setVendorList(filteredData)
  
  }
}

const handleFilterChange = async (data) => {

  try {

    // Switch-case statement to select endpoint based on selected report
   

    let postData={
      page: currentPage,
   
    }
    if (data) {
      const response = await makeApiCall(Api_Endpoints.VENDOR_LIST, 'GET',postData);
if(response?.status===200){
  setVendorList(response?.data?.data)
  setError("")

if(response?.data?.data.length!==0){

  showSuccessToast('Record Found')

  }

}
else{
  setError(response?.message || "No vendors found");
  setVendorList([]);
  showErrorToast(response?.message)
}

    } else {
      console.log('Invalid report selected');
    }
  } catch (error) {
    console.error('Error occurred while fetching data:', error);
  }
};

const handleSearchChange = (event) => {
  
  setFilterValue(prevData=>({
    ...prevData,searchParam:event.target.value
  }))
};

const handleReset = () => {
  setFilterValue({
    searchParam: '',
    productType: '',
    Status: ''
  });
  // setVendorList([])

  GetVendorList();

  // handleReset={handleReset}

};
const handleDropdownChange =(e,field)=>{
  const selectedValue=e.target.value;
  setFilterValue(prevData=>({
    ...prevData,[field]:selectedValue
  })) 
}


const fetchData=async()=>{
  const getstatus =      await   makeApiCall(Api_Endpoints.getStatus, 'GET');
  
  if(getstatus?.status===200){
    const dropdownData = [
     
      {
        label: "status",
        placeholder: 'Select Status',
        options: getstatus.data?.map((data) => ({
          value: data.status_id, // Assuming your API response contains a 'value' field
          label: data.name // Assuming your API response contains a 'label' field
        }))
      },
      // Add more dropdown objects as needed
    ];
  setdropDownData(dropdownData)
  
  
  
  }else
  {
    showErrorToast(getstatus?.message)
  }
  
    }


    useEffect(()=>{fetchData()
      console.log(VendorList)
    },[])
useEffect(()=>{

},[filterValue,VendorList])



    return (
      <div style={{height:'100%'}}>
      
     
        {/* <div className=" flex justify-center w-full p-8 mx md:w-[75%] max-w-[95%] bg-white lg:max-h-80 min-h-fit -mt-20 border border-neutral-light rounded mb-4 ">
          <LineChart />
        </div> */}
      {error && (
        <div className="error-container">
          <span className="error-message">{error}</span>
        </div>
      )}


      <FilterContainer
      dropdownData={dropDownData}
        handleSearchChange={handleSearchChange}
        handleDropdownChange={handleDropdownChange}
        ResetList={handleReset}
        product={product}
        handleFilterChange={handleFilterChange}
        status={status}
        searchData={searchData}
        type="vendor"
        pageType= "vendor"
      />

            <div className="flex gap-5">
              <h1 className="text-2xl font-bold mb-4">Vendor List</h1>
              
              <Tippy
                content={
                  isRefreshButtonDisabled ? "wait 10 sec " : "Refresh Files"
                }
                placement="right"
                arrow={true}
                className="rounded-sm text-xs"
              >
                
              </Tippy>
            </div>
            
  
            
            <ListTable data={VendorList} refresh={refreshpage} />
  
            <div style={{display:'flex',justifyContent:'space-between',marginRight:'10px',alignItems:'center'}}>
              <span style={{color:'black'}}>
                Showing {indexOfFirstRecord + 1} to {indexOfFirstRecord + 10} of{" "}
                {totalRecords} entries
              </span>
              <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
              <span style={{color:'black'}}>
                  Page {currentPage} of {totalPage}
                </span>
          {currentPage > 1 && 
                <p
  className='paginationbutton'
onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Prev
                </p>}
              {currentPage < totalPage && 
                <p
                  className='paginationbutton'
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPage}
                  
                >
                  Next
                </p>}
              </div>
            </div>
       
      </div>
    );
  }

export default ClaimListPage;